import { canv } from "@/canv/global.js";
import { elementBase } from "@/elementBase/elementBase";
import type { Group } from "@/group";
import type { widgetOption } from "./widgetMenu";

export class wmBase {
    build(): string | undefined {
        return;
    }

    init() {}

    getUniqs() {
        const uniqValues: Array<widgetOption["value"]> = [];

        for (let i = 0; i < this.options.length; i++) {
            const option = this.options[i];
            let uniqFound = false;
            for (let k = 0; k < uniqValues.length; k++) {
                if (uniqValues[k] === option.value) {
                    uniqFound = true;
                }
            }

            if (!uniqFound) {
                uniqValues.push(this.options[i].value);
            }
        }
        return uniqValues;
    }

    async applyValue(options: widgetOption[], value: any, closeSubMenu = true, makeEvent = true) {
        const settedUIDs: string[] = [];
        if (makeEvent) canv.eventManager.openRecord();

        for (let i = 0; i < options.length; i++) {
            const index = settedUIDs.indexOf(options[i].UID);
            if (index !== -1) continue; // если уже сетили такой виджет. Такое может быть. Например таблица может вернуть несколько цветов (разные цвета у разных ячеек)

            const widget = canv.canvasController.FindByUID(options[i].UID);
            if (!widget) continue; // проверяем, что есть такой виджет
            if (!(widget instanceof elementBase)) return; // проверяем что это не группа

            settedUIDs.push(options[i].UID);

            const handler = widget.getHandlerForOption(options[i].name);
            if (!handler) continue; // проверяем, что есть обработчик
            const bindedFunc = handler.bind(widget);

            if (makeEvent && widget.parent) (widget.parent as Group).fixWidgets(this.name);

            await bindedFunc(value);
            options[i].value = value;
            if (makeEvent && widget.parent) (widget.parent as Group).saveWidgets(this.name);
        }

        if (makeEvent) canv.eventManager.closeRecord();
        if (closeSubMenu) {
            const otherSubm = document.querySelector<HTMLElement>(".widgetSubMenu");
            if (otherSubm) {
                otherSubm.outerHTML = "";
            }
        }

        canv.redraw();
    }

    options: widgetOption[] = [];
    name = "wmBase";
}
